import { QueryClient } from "@tanstack/react-query";
import { AxiosInstance } from "axios";
import { calculationKey, CalculationStatus } from "./calculationQuery";

export type CalculationSubmitInput = {
  id: number;
  idBusiness: number;
  idBranch: number | null;
  calculatedStartDate: string;
  calculatedEndDate: string;
  name: string;
  email: string;
  phone: string;
  memo: string;
  fileUrls: string[];
  calculationStatus: CalculationStatus;
  reasonOfDisapproval: string | null;
};

export const calculationSubmitMutation = (
  client: AxiosInstance,
  queryClient: QueryClient
) => ({
  mutationFn: (input: CalculationSubmitInput) =>
    client
      .request({
        method: "PUT",
        url: `v1/calculations/submit/${input.id}`,
        data: input,
      })
      .then((response) => response.data),
  onSuccess: (_: unknown, input: CalculationSubmitInput) => {
    queryClient.invalidateQueries(calculationKey(input.id));
  },
});
